import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4bab4a3c&"
var script = {}
import style0 from "@/assets/css/element-m.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/assets/css/app.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_frtorbnrps7mwsvjkhwiayewvm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports